import { Avatar, AvatarFallback, AvatarImage } from "@tellescope/ui";
import type { MultiSelectOption } from "@tellescope/ui";

interface CareTeamMemberOptionProps {
  option: MultiSelectOption;
  avatar?: string;
  initials: string;
}

export const CareTeamMemberOption = ({ option, avatar, initials }: CareTeamMemberOptionProps) => (
  <div className="flex items-center gap-2">
    <Avatar className="h-6 w-6">
      <AvatarImage src={avatar} />
      <AvatarFallback useStaticBackground id={option.value}>
        {initials}
      </AvatarFallback>
    </Avatar>
    <span className="text-sm truncate">{option.label}</span>
  </div>
);
